import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Projects', href: '#projects' },
    { label: 'About Us', href: '#about' },
    { label: 'Contact', href: '#contact' }
  ];

  const services = [
    'EPC Services',
    'Workshop & Assembly',
    'Retail & Dealership',
    'Maintenance Contracts',
    'Technical Consultation'
  ];

  const certifications = [
    'EPRA Certified',
    'NCA Approved',
    'ICT Certified',
    'ISO 9001:2015'
  ];

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <AppImage
                src="/assets/images/New_Capital_for_General_Contracting_Company_Profile_Overview_New_Capital_for_General_Contracting_final_hassan-1768050880430.jpeg"
                alt="New Capital for General Contracting Company Logo"
                width={48}
                height={48}
                className="rounded-lg object-cover"
              />
              <div className="flex flex-col">
                <span className="font-headline font-bold text-xl leading-tight">New Capital</span>
                <span className="font-body text-sm opacity-80 leading-tight">EPC Solutions</span>
              </div>
            </div>
            <p className="font-body text-sm opacity-80 mb-6">
              Africa's fastest-growing EPC company delivering world-class electrical and mechanical engineering solutions across East Africa.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-accent flex items-center justify-center transition-all duration-250">
                <Icon name="GlobeAltIcon" size={20} variant="outline" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-accent flex items-center justify-center transition-all duration-250">
                <Icon name="EnvelopeIcon" size={20} variant="outline" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-accent flex items-center justify-center transition-all duration-250">
                <Icon name="PhoneIcon" size={20} variant="outline" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-headline text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.href}
                    className="font-body text-sm opacity-80 hover:opacity-100 hover:text-accent transition-all duration-250 inline-flex items-center gap-2"
                  >
                    <Icon name="ChevronRightIcon" size={16} variant="outline" />
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline text-lg font-bold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services?.map((service) => (
                <li key={service}>
                  <span className="font-body text-sm opacity-80 inline-flex items-center gap-2">
                    <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-accent" />
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline text-lg font-bold mb-6">Certifications</h3>
            <ul className="space-y-3 mb-6">
              {certifications?.map((cert) => (
                <li key={cert}>
                  <span className="font-body text-sm opacity-80 inline-flex items-center gap-2">
                    <Icon name="ShieldCheckIcon" size={16} variant="solid" className="text-success" />
                    {cert}
                  </span>
                </li>
              ))}
            </ul>
            <div className="bg-white/10 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="MapPinIcon" size={20} variant="solid" className="text-accent" />
                <span className="font-body font-semibold text-sm">Head Office</span>
              </div>
              <p className="font-body text-xs opacity-80">
                KG 11 Ave, Kigali, Rwanda<br />
                +250 788 123 456<br />
                eng@new-capital.capital
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-sm opacity-80 text-center md:text-left">
              &copy; {currentYear} New Capital for General Contracting Ltd. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <a href="#" className="font-body text-sm opacity-80 hover:opacity-100 hover:text-accent transition-all duration-250">
                Privacy Policy
              </a>
              <a href="#" className="font-body text-sm opacity-80 hover:opacity-100 hover:text-accent transition-all duration-250">
                Terms of Service
              </a>
              <a href="#" className="font-body text-sm opacity-80 hover:opacity-100 hover:text-accent transition-all duration-250">
                GDPR Compliance
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;